<script>
    import axios from "axios";
    axios.defaults.xsrfHeaderName = "X-CSRF-TOKEN";
    axios.defaults.xsrfCookieName = "csrf_access_token";

    import { successToast, errorToast500 } from "../../utils/CommonToasts";

    import Input from "../../components/Inputs/Input.svelte";
    import Button from "../../components/Buttons/Button.svelte";
    import TextArea from "../../components/Inputs/TextArea.svelte";
    import Radio from "../../components/Inputs/Radio.svelte";

    export let user;

    let isSubmitting = false;

    const submitHandler = async () => {
        isSubmitting = true;
        await axios
            .patch(
                APIBACKEND + "/user",
                { user: user },
                { withCredentials: true }
            )
            .then(function (res) {
                if (res.status === 200) {
                    successToast("Your profile has been successfully saved 👍");
                    setTimeout(function () {
                        isSubmitting = false;
                    }, 3500);
                } else {
                    errorToast500();
                }
            });
    };
</script>

<style lang="scss">
    @import "../../styles/_mixins.scss";

    .profile-settings {
        margin: 0 auto;
        padding-left: var(--spacer-medium);
        padding-right: var(--spacer-medium);

        @include sm {
            margin-top: var(--spacer-large);
            align-self: flex-start;
            max-width: 712px;
            padding: 0;
        }

        :global(.input-container) {
            margin-bottom: var(--spacer-medium);
        }

        :global(.input-container):last-of-type {
            margin-bottom: var(--spacer-medium);
        }
    }
</style>

<form class="profile-settings" on:submit|preventDefault={submitHandler}>
    <Input
        name="first_name"
        label="What's your first name?"
        placeholder="Arthur"
        bind:value={user.first_name}
        type="text" />

    <Input
        name="last_name"
        label="What's your last name?"
        placeholder="Dent"
        bind:value={user.last_name}
        type="text" />

    <Input
        name="linkedin"
        label="What's your Linkedin?"
        placeholder="https://www.linkedin.com/in/yourusername/"
        bind:value={user.linkedin}
        type="url" />

    <Input
        name="location"
        label="Where are you based?"
        placeholder="London, UK"
        bind:value={user.location}
        helperText="Please enter a city followed by the country"
        type="text" />

    <Radio
        name="technical"
        label="Are you a technical founder?"
        selected={user.technical}
        onClick={(result) => (user.technical = result)}
        required />

    <Radio
        name="experience"
        label="Do you have previous experience as a founder?"
        selected={user.experience}
        onClick={(result) => (user.experience = result)}
        required />

    <Input
        name="email"
        label="What's the best way to keep in contact?"
        value={user.email}
        helperText="We haven't yet added functionality to change your email - please contact us to do so!"
        disabled
        type="email" />

    <Input
        name="avatar"
        label="Profile Image"
        value={user.avatar}
        disabled
        helperText="We use Gravatar for your profile image for now, we'll add the ability to upload your own image soon."
        type="text" />

    <Button
        primary
        text="Save"
        position="right"
        buttonType="submit"
        disabled={isSubmitting} />
</form>
